/**
 * @namespace BX.UI.Uploader
 */
export const FilterType = {
	VALIDATION: 'validation',
	PREPARATION: 'preparation',
};
